export { mapPrismicProp } from './helpers';
export { default } from './ReactFromPrismic';
